module.exports = __webpack_public_path__ + "img/20190612_132334_018.35b934da.jpg";